import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { Validators, DatePickerRangeField, ChosenCarField } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t?: Function;
};
type P = {
    onCarRemoval: Function;
    onListOpen: Function;
};

const CarMainReport = (props: InjectedFormProps & ConnectedProps & P) => {
    const { handleSubmit, pristine, submitting, t, initialValues } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field
                name="dateRangeFromTo"
                component={DatePickerRangeField}
                type="text"
                placeholder={t('dateRange')}
                label={t('dateRange')}
                validate={[Validators.required]}
                endDateLabel={t('endDate')}
                startDateLabel={t('startDate')}
                dateRangePlaceholder={t('dateRangePlaceholder')}
            />
            <Field
                name="car_id"
                component={ChosenCarField}
                type="text"
                placeholder={t('choosenCar')}
                label={t('choosenCar')}
                onListOpen={() => props.onListOpen()}
                onCarRemoval={() => props.onCarRemoval()}
                labelNoCar={t('labelNoCar')}
            />
            <div className="flex flex--justify-center">
                <button disabled={submitting || pristine || !initialValues['car_id']} className="btn btn--blue" type="submit">
                    {t('generateReport')}
                </button>
            </div>
        </form>
    );
};

function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors', 'carDetails']),
    reduxForm({
        form: 'CarMainReport',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(CarMainReport) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/CarMainReportForm.tsx